type HeaderMenuHandlers = {
  onPressLogout?: (() => void) | null;
};

let logoutHandler: (() => void) | null = null;

export const setHeaderMenuHandlers = (handlers: HeaderMenuHandlers) => {
  logoutHandler = handlers.onPressLogout ?? null;
};

export const triggerHeaderMenuLogout = () => {
  if (!logoutHandler) return false;
  logoutHandler();
  return true;
};
